import React from 'react';
import star from '../../assets/star-20.svg';

const BannerScrollItem = ({ text }) => {
  return (
    <div className="flex flex-row items-center gap-1 whitespace-nowrap">
      <img src={star} className="w-6" alt="star icon" />
      <p className="text-[#ECF2E1]">{text}</p>
    </div>
  );
};

const BannerInfoScroll = () => {
  return (
    <div className='py-2 bg-[#0E0E10] text-[#ECF2E1] uppercase text-[0.8rem] font-[400] w-full border-y border-y-[#1C1C21] overflow-hidden'>
          <div className="flex flex-row gap-6  banner-scroll whitespace-nowrap">
      <BannerScrollItem text="Building for people" />
      <BannerScrollItem text="Frontend engineering" />
      <BannerScrollItem text="Artificial intelligence" />
      <BannerScrollItem text="Digital experiences" />
      <BannerScrollItem text="UX optimization" />
      <BannerScrollItem text="Accessibility" />
      <BannerScrollItem text="Product thinking" />
      <BannerScrollItem text="Product development" />
      <BannerScrollItem text="Usability" />

              {/* Duplicate the items here */}
              <BannerScrollItem text="Building for people" />
      <BannerScrollItem text="Frontend engineering" />
      <BannerScrollItem text="Artificial intelligence" />
      <BannerScrollItem text="Digital experiences" />
      <BannerScrollItem text="UX optimization" />
      <BannerScrollItem text="People centric" />
      <BannerScrollItem text="Product thinking" />
      <BannerScrollItem text="Product development" />
      <BannerScrollItem text="API integration" />
      <BannerScrollItem text="Systems thinking" />
    </div>
    </div>
  );
};

export default BannerInfoScroll;
